var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 9.37225V3.84025H16.8V1.44025H7.19999V3.84025H8.39999V9.37225L1.36799 21.2282C1.25997 21.4104 1.20209 21.618 1.20024 21.8298C1.19839 22.0416 1.25263 22.2501 1.35745 22.4341C1.46228 22.6182 1.61394 22.7712 1.79705 22.8777C1.98016 22.9841 2.18818 23.0402 2.39999 23.0402H21.6C21.8118 23.0402 22.0198 22.9841 22.2029 22.8777C22.386 22.7712 22.5377 22.6182 22.6425 22.4341C22.7473 22.2501 22.8016 22.0416 22.7997 21.8298C22.7979 21.618 22.74 21.4104 22.632 21.2282L15.6 9.37225ZM10.56 10.4282C10.7158 10.2205 10.8 9.96789 10.8 9.70825V3.84025H13.2V9.70825C13.2 9.92363 13.2581 10.135 13.368 10.3202L15.936 14.6402H8.06399L10.56 10.4282Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabIcon);
export default __webpack_public_path__ + "static/media/lab-icon.c0109fb7a9b9540d34db1a81c0aeabb8.svg";
export { ForwardRef as ReactComponent };